import { render, staticRenderFns } from "./AscConfirmation.vue?vue&type=template&id=b2b2cb10&"
import script from "./AscConfirmation.vue?vue&type=script&lang=js&"
export * from "./AscConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./AscConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports